import { useEffect, useState } from 'react';
import { Fleet } from '@bringg/types';

import { useAuth } from 'Providers';

export function useFleets(): Fleet[] {
  const { dashboardSdk, isLoggedIn } = useAuth();
  const [fleets, setFleets] = useState([]);

  useEffect(() => {
    if (!dashboardSdk || !isLoggedIn) {
      setFleets([]);
      return;
    }

    async function fetchFleets() {
      setFleets(await dashboardSdk.sdk.fleets.getAll());
    }

    fetchFleets();
  }, [dashboardSdk, isLoggedIn]);

  return fleets;
}
